export default "__VITE_ASSET__4myEI00c__"